import { getRgObjectsOfType as p, RG_TYPE as a, sum as i } from "@project-rouge/rg-core";
import { getPolygonArea as n } from "../../geometry-utils/core/index14.js";
const u = (e, r) => {
  if (r && (e = r.flatMap((t) => p(e, t))), "uuid" in e) {
    if (e.type === a.World)
      return u(e, [a.Site]);
    if (e.type === a.Site)
      return c(e);
    if (e.type === a.Zone)
      return l(e);
    const t = e.data ? e.data.polygon : void 0;
    return t ? n(t) : e.size[0] * e.size[2];
  }
  return e.map((t) => u(t)).reduce(i, 0);
};
function l(e) {
  const r = n(e.data.realPoly), t = e.data.holes.map((d) => n(d)).reduce(i, 0);
  return r - t;
}
function c(e) {
  return e.children.length > 0 ? e.children.map((r) => l(r)).reduce(i, 0) : n(e.data.polygon);
}
export {
  u as getArea
};
//# sourceMappingURL=index3.js.map
